export const responsiveStyles = {
  // Container styles
  container: {
    display: 'flex',
    minHeight: '100vh',
    fontFamily: "'Inter', system-ui, sans-serif",
    '@media (max-width: 768px)': {
      flexDirection: 'column'
    }
  },

  // Sidebar styles
  sidebar: {
    width: '260px',
    background: 'linear-gradient(135deg, #1e3a5f 0%, #0f2b42 100%)',
    padding: '30px 20px',
    overflowY: 'auto',
    '@media (max-width: 768px)': {
      display: 'none'  // ← Hide sidebar completely on mobile
    }
  },

  // Main content styles
  main: {
    flex: 1,
    background: '#f8fafc',
    padding: '30px',
    overflowY: 'auto',
    '@media (max-width: 768px)': {
      padding: '80px 15px 15px 15px',  // Add top padding for mobile header
      marginTop: 0
    }
  },

  // Grid styles
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(380px, 1fr))',
    gap: 24,
    '@media (max-width: 768px)': {
      gridTemplateColumns: '1fr',
      gap: 16
    }
  },

  // Stats grid
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
    gap: 20,
    marginBottom: 30,
    '@media (max-width: 768px)': {
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: 12
    }
  },

  // Charts grid
  chartsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(450px, 1fr))',
    gap: 24,
    '@media (max-width: 768px)': {
      gridTemplateColumns: '1fr',
      gap: 16
    }
  },

  // Two column grid
  twoColumnGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
    gap: 24,
    '@media (max-width: 768px)': {
      gridTemplateColumns: '1fr',
      gap: 16
    }
  }
}

// Media query helper
export const mediaQuery = {
  mobile: '@media (max-width: 768px)',
  tablet: '@media (min-width: 769px) and (max-width: 1024px)',
  desktop: '@media (min-width: 1025px)'
}